const themes = {
  dark: () => import("./toyotaTheme"),
  toyota: () => import("./toyotaTheme"),
  default: () => import("./defaultTheme")
};

const themeLoader = async (franchises = [], removeColor = false) => {
  let loader;

  if (removeColor) {
    loader = themes.dark;
  }

  let i = 0;
  while (!loader) {
    let franchise = franchises[i];
    if (!franchise) {
      franchise = "default";
    }
    loader = themes[franchise.toLowerCase()];
    i++;
  }
  const module = await loader();
  return module.default;
};

export default themeLoader;
